// import { useParams } from "react-router-dom";
import SavePreventaCoperativo from "../../shared/save_preventa_coperativo/SavePreventaCorporativa";
// import { LoaderComponent } from "@/shared/components/ui";
// import {  useGetProspectoByIdProspectoCorporativo } from "@/shared/actions/erp/prospecto_corporativo.actions";

export default function NPreventaProspectoCorporativa() {

  return (
    <SavePreventaCoperativo
      title="Crear Oportunidad Comercial con Proyecto Previo"
      dataProspecto={undefined}
      enableEdit={true}
      withPreviousProspecto={true}
    />
  )

}